import classNames from 'classnames'

interface ChipRowProps {
  selectedOptions: string[]
  onClick: (label: string) => void
  isMobile: boolean
}

const ChipRow = ({ selectedOptions, onClick, isMobile }: ChipRowProps) => {
  return (
    <div className="flex gap-2 overflow-x-scroll no-scrollbar">
      {selectedOptions.map((option) => {
        return (
          <div
            role="button"
            key={`chip-for-${option}`}
            className={classNames(
              'w-fit border-[1px] border-white px-2 text-white rounded-[17px] flex flex-row gap-1 items-center font-decimal whitespace-nowrap',
              isMobile ? 'text-[16px] py-2' : 'text-[12px] py-1'
            )}
            onClick={() => onClick(option)}
          >
            <span>—</span>
            <span>{option}</span>
          </div>
        )
      })}
    </div>
  )
}
export default ChipRow
